import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Vuetify, {
  VApp,
  VToolbar,
  VContent,
  VIcon,
  VBtn,
  VContainer,
  VLayout,
  VFlex,
  VSpacer,
  VForm,
  VProgressCircular,
  VSnackbar,
  VAutocomplete,
  VMenu,
  VDatePicker,
  VTextField
} from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'
import 'vuetify/src/stylus/app.styl'
import 'vuetify/dist/vuetify.min.css'

import VueResource from 'vue-resource'

import VueI18n from 'vue-i18n'
import en from './locale/en'
import es from './locale/es'

Vue.config.productionTip = false

Vue.use(Vuetify, {
  locale: (navigator.language || navigator.userLanguage).split('-')[0] === 'es' ? 'es' : 'en',
  theme: {
    primary: '#7bc3bd',
    secondary: '#4e5f67',
    error: '#D32F2F'
  },
  components: {
    VApp,
    VToolbar,
    VContent,
    VIcon,
    VBtn,
    VContainer,
    VLayout,
    VFlex,
    VSpacer,
    VForm,
    VProgressCircular,
    VSnackbar,
    VAutocomplete,
    VMenu,
    VDatePicker,
    VTextField
  },
  directives: {
    Ripple
  }
})

window.moment = require('moment')

Vue.use(VueResource)
Vue.http.interceptor.before = function (request, next) {
  store.commit('state/setLoading', true)
  next(response => {
    if (!response.ok && response.status === 401) {
      router.push({ name: 'unauthorized' })
    }
    store.commit('state/setLoading', false)
  })
}

Vue.use(VueI18n)
const messages = {
  en,
  es
}
const i18n = new VueI18n({
  locale: (navigator.language || navigator.userLanguage).split('-')[0] === 'es' ? 'es' : 'en',
  messages
})

window.vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
